module.exports = __webpack_public_path__ + "img/adorno-1.995a4fb9.png";